import { UMR } from '../../urbanmap/_components';
import { planStatus } from './model';
import type { Project, Tab } from './types';
import { ACCENT } from './ui';
import { NJButton } from '@engie-group/fluid-design-system-react';

interface SectionDef {
  key: Tab;
  label: string;
  icon: string;
  disabled?: boolean;
  badge?: string;
}

const SECTIONS: SectionDef[] = [
  { key: 'params', label: 'Paramètres projet', icon: 'settings' },
  { key: 'selections', label: 'Outils UM', icon: 'select_all' },
  { key: 'plans', label: 'Plans de dev', icon: 'account_tree' },
  { key: 'hypotheses', label: 'Hypothèses', icon: 'tune' },
  { key: 'optimization', label: 'Optimisation', icon: 'insights', badge: 'V2' },
  { key: 'exchange', label: 'Import-export', icon: 'import_export' },
];

/**
 * Rail de sections figé (toujours visible) : navigue entre les grandes sections de l'outil.
 * Icône + libellé court, dans l'esprit du rail de la maquette PO (Config projet, Couches…).
 */
export function SectionRail({ project, tab, onChange }: { project: Project; tab: Tab; onChange: (t: Tab) => void }) {
  const setCount = project.sets.demande.length + project.sets.trace.length + project.sets.developpement.length
    + project.sets.phasage.length + project.sets.importance.length + project.sets.pointsDepart.length;
  const stale = project.plans.filter((pl) => planStatus(project, pl) === 'stale').length;
  const counter: Record<Tab, string> = {
    hypotheses: `${setCount} jeux`,
    selections: `${project.selections.length} sélection${project.selections.length > 1 ? 's' : ''}`,
    plans: `${project.plans.length} plan${project.plans.length > 1 ? 's' : ''}`,
    optimization: '',
    params: '',
    exchange: '',
  };

  return (
    <nav aria-label="Sections du projet" style={{ flex: '0 0 104px', width: 104, borderRight: `1px solid ${UMR.border}`, background: UMR.white, display: 'flex', flexDirection: 'column', paddingTop: 8 }}>
      {SECTIONS.map((s) => {
        const active = tab === s.key;
        return (
          <NJButton
            key={s.key}
            label={s.label}
            variant={active ? 'primary' : 'secondary'}
            emphasis={active ? undefined : 'minimal'}
            scale="sm"
            aria-current={active ? 'page' : undefined}
            onClick={() => !s.disabled && onChange(s.key)}
            disabled={s.disabled}
            title={`${s.label} · ${counter[s.key]}${s.key === 'plans' && stale ? ` · ${stale} obsolète(s)` : ''}`}
            style={{
              position: 'relative', cursor: s.disabled ? 'not-allowed' : 'pointer', fontFamily: UMR.font, border: 0,
              borderLeft: `3px solid ${active ? ACCENT : 'transparent'}`,
              background: active ? 'var(--nj-core-color-teal-100, #e3f4f2)' : 'transparent',
              color: active ? ACCENT : UMR.text,
              padding: '12px 4px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
            }}
          />
        );
      })}
    </nav>
  );
}
